module.exports = __webpack_public_path__ + "ipetbooking-landing/img/pic01@1.1d22d689.jpg";